import React, { useState, useEffect, Fragment, useContext } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import SchoolUtilitySeller from './SchoolUtilitySeller';

const UtilitySeller = ({usuario}) => {

	const authContext = useContext(AuthContext);
	const { getSchoolID, schoolID } = authContext;

	useEffect(() => {
		getSchoolID();
    }, []);

	return (

		<SchoolUtilitySeller 
			schoolID={schoolID}
			usuario={usuario}
		/>

	);
};

export default UtilitySeller;
